import { connect } from 'react-redux'
import { compose, withHandlers } from 'recompose'
import { placeThread } from '../../../store/actions/discuss'
import {
  orderedBlockLayoutSelector,
  colWidthSelector,
  sectionLayoutAdjustedSelector,
  currentBlockSizeSelector
} from '../../../store/selectors/boardSelectors'
import { currentBlockIdSelector } from '../../../store/selectors/selectors'

const PlaceThreadContianer = compose(
  connect(
    state => {
      const currentBlockId = currentBlockIdSelector(state)
      if (currentBlockId) {
        const currentBlockSize = currentBlockSizeSelector(state)
        return {
          blocks: [
            {
              id: currentBlockId,
              layout: currentBlockSize
            }
          ]
        }
      } else {
        const colWidth = colWidthSelector(state)
        const blocks = orderedBlockLayoutSelector(state)
        const sections = sectionLayoutAdjustedSelector(state)
        return {
          blocks: Object.keys(blocks || {}).map(id => ({
            id,
            layout: blocks[id].scale(colWidth).style
          })),
          sections: [...sections.values()].map(section => ({
            id: section.id,
            top: section.top * colWidth,
            height: Math.max(section.height, section.minHeight) * colWidth
          }))
        }
      }
    },
    { placeThread }
  ),
  withHandlers({
    placeBlockThread: ({ placeThread }) => (event, blockId) => {
      event.stopPropagation()
      return placeThread({
        blockId,
        left: event.nativeEvent.offsetX / event.currentTarget.offsetWidth,
        top: event.nativeEvent.offsetY / event.currentTarget.offsetHeight
      })
    },
    placeSectionThread: ({ placeThread }) => (event, sectionId) => {
      event.stopPropagation()
      return placeThread({
        sectionId,
        left: colWidth => event.nativeEvent.offsetX / colWidth,
        top: colWidth => event.nativeEvent.offsetY / colWidth
      })
    }
  })
)

export default PlaceThreadContianer
